module.exports = __webpack_public_path__ + "img/BTCB.928e7f5f.png";